module.exports = __webpack_public_path__ + "static/media/Lens-Fresh_Grayzel_TW.8e0eaba4.png";